import BookmarkDetail from "@/Component/Brand/SaveList/BookmarkDetail";


const BookmarkDetailPage = async ({ params }: { params: Promise<{ slug: string | string[] }>; }) => {
  const resolvedParams = await params;
  const slug = decodeURIComponent(Array.isArray(resolvedParams.slug)
    ? resolvedParams.slug[0]
    : resolvedParams.slug);

  return <BookmarkDetail slug={slug} />;
};

export default BookmarkDetailPage;
